module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("月数据")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年月"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-09"
    },
    model: {
      value: (_vm.queryParam.periodLabel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "periodLabel", $$v)
      },
      expression: "queryParam.periodLabel"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [20, 50, 100]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16531f70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentMonthStatList.vue
// module id = 1664
// module chunks = 8